module.exports = __webpack_public_path__ + "static/img/06_雲講機.fa09df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/06_雲講機.png
// module id = vBuf
// module chunks = 1